"use client";
import { useEffect } from "react";
import { sendPv } from "@/tracks/25157";

export default function Effect() {
  useEffect(() => {
    sendPv.Search_ProductList();
  }, []);
  return null;
}
